
import { Vue, Component, Prop } from 'vue-property-decorator';
import pdf from 'vue-pdf';

@Component({
  components: {
    pdf,
  },
})
export default class LookPDFModal extends Vue {
  @Prop()
  width!: number;

  pdfUrl = '';

  visible = false;

  pageTotal = 0;

  init(url: string) {
    this.pdfUrl = url;
    this.getNumPages(url);
    this.visible = true;
  }

  getNumPages(url: string | ArrayBuffer): void {
    const loadingTask = pdf.createLoadingTask(url);
    loadingTask.promise
      .then((pdfDoc: any) => {
        console.log('获取PDF页数成功', pdfDoc.numPages);
        this.pageTotal = pdfDoc.numPages;
      })
      .catch((err: any) => {
        console.error('获取PDF页数失败', err);
      });
  }
}
